// extracted by mini-css-extract-plugin
export default {"bottomBorder":"_927ee87e","small":"_c1dc5d22","medium":"_7dcf240","large":"_8a1e7740","xLarge":"_764d8d38","xxLarge":"_3e761920","isTrade":"_b6f68701"};